// src/components/shared/BootstrapShell.js
//
// Pass 86P — the deterministic, branded bootstrap state shown while canonical auth/identity/org data is still
// resolving. It replaces the previous blank screen (AuthProvider rendered NOTHING until `loading` was false).
//
// Principle (durable): LOADING/UNKNOWN is permitted; WRONG is not. This shell shows a neutral Voletus-branded
// placeholder — NEVER a fake identity, initials, org or workspace — until the real state resolves, at which point
// the app transitions atomically to the canonical UI. Dependency-free and tiny so it is always available instantly.

import React from 'react';

const font = "'DM Sans',system-ui,-apple-system,sans-serif";

export default function BootstrapShell({ label = 'Loading your workspace…' }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={{
        position: 'fixed', inset: 0, background: '#f4f4f2', display: 'flex',
        flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 18, fontFamily: font,
      }}
    >
      <style>{`@keyframes voletus-boot-spin{to{transform:rotate(360deg)}}`}</style>
      {/* Neutral Voletus wordmark — brand, not identity */}
      <div style={{ fontSize: 26, fontWeight: 800, letterSpacing: -0.5, color: '#1a1917' }}>voletus</div>
      <div
        aria-hidden="true"
        style={{
          width: 26, height: 26, borderRadius: '50%',
          border: '3px solid rgba(37,99,235,0.18)', borderTopColor: '#2563eb',
          animation: 'voletus-boot-spin 0.8s linear infinite',
        }}
      />
      <div style={{ fontSize: 13, color: '#8a8980' }}>{label}</div>
    </div>
  );
}
